// Source: Anastasia Rydaeva, lubimyczytac-tags-dark-romance-romantasy.pdf,
// logged-out Lubimyczytać tag pages, 2–3 November 2026.
// Counts and abbreviated book credits are transcribed from the contributor's PDF.
export type PolishTagRow = [tag: string, englishTag: boolean, meaning: string, books: number, readers: number, book: string];
export type PolishTagGroup = { genre: 'dark-romance' | 'romantasy'; title: string; rows: PolishTagRow[] };

export const polishTagGroups: PolishTagGroup[] = [
  {
    genre: 'dark-romance',
    title: 'Genre labels',
    rows: [
      ["romans mafijny", false, "mafia romance", 199, 74232, "Złączeni honorem · Cora Reilly"],
      ["dark romance", true, "–", 843, 57737, "Corrupt · Penelope Douglas"],
      ["hate-love", false, "hate to love readers' coinage", 119, 53042, "Punk 57 · Penelope Douglas"],
      ["romans hate-love", false, "hate-to-love romance", 15, 21830, "Devil · Julia Brylewska"],
      ["dark romans", false, "dark romance Polish spelling", 84, 20320, "I see you · Ker Dukey"],
      ["dark erotyk", false, "dark erotica", 11, 4618, "Nieczyste więzy · K.N. Haner"],
    ],
  },
  {
    genre: 'dark-romance',
    title: 'Themes and hooks',
    rows: [
      ["zemsta", false, "revenge", 794, 532919, "Ojciec chrzestny · Mario Puzo"],
      ["obsesja", false, "obsession", 306, 311810, "Na skraju załamania · B.A. Paris"],
      ["porwanie", false, "kidnapping", 475, 253096, "W pustyni i w puszczy · Henryk Sienkiewicz"],
      ["mafia", false, "mafia", 982, 229742, "Ojciec chrzestny · Mario Puzo"],
      ["półświatek", false, "the underworld", 68, 130004, "Ślepnąc od świateł · Jakub Żulczyk"],
      ["gangster", false, "gangster", 66, 59901, "Złączeni honorem · Cora Reilly"],
      ["stalking", true, "–", 31, 32424, "Spójrz na mnie · Nicholas Sparks"],
      ["stalker", true, "–", 69, 31462, "W ukryciu · Lisa Gardner"],
      ["toksyczny związek", false, "toxic relationship", 27, 15732, "Tak blisko... · Tammara Webber"],
      ["maska", false, "mask masked hero", 26, 12250, "Lights Out · Navessa Allen"],
      ["toksyczna miłość", false, "toxic love", 14, 11557, "Bardzo biała wrona · Ewa Nowak"],
      ["antybohater", false, "antihero", 12, 9224, "A jeśli jesteśmy złoczyńcami · M. L. Rio"],
      ["bratva", true, "Russian mafia", 30, 8107, "Krwawy obowiązek. Sophia. · Amelia Sowiń…"],
    ],
  },
  {
    genre: 'dark-romance',
    title: 'Tropes',
    rows: [
      ["różnica wieku", false, "age gap", 165, 71527, "Złączeni obowiązkiem · Cora Reilly"],
      ["age gap", true, "–", 194, 67726, "Złączeni obowiązkiem · Cora Reilly"],
      ["aranżowane małżeństwo", false, "arranged marriage", 47, 30984, "Złączeni pokusą · Cora Reilly"],
      ["hate to love", true, "–", 23, 21530, "Corrupt · Penelope Douglas"],
      ["tw", true, "trigger warning", 7, 9869, "Gild · Raven Kennedy"],
      ["bully romance", true, "–", 41, 9680, "Deviant King · Rina Kent"],
      ["małżeństwo z rozsądku", false, "marriage of convenience", 18, 7742, "Kontrakt Jacksona · J.T. Geissinger"],
    ],
  },
  {
    genre: 'dark-romance',
    title: 'Heat level',
    rows: [
      ["erotyka", false, "erotica", 1331, 166377, "365 dni · Blanka Lipińska"],
      ["erotyk", false, "erotic novel", 850, 136057, "Ciemniejsza strona Greya · E. L. James"],
      ["spicy", true, "–", 571, 26172, "Christmas Wishlist · Marcelina Bobeł"],
      ["smut", true, "–", 1052, 4653, "Flock · Kate Stewart"],
    ],
  },
  {
    genre: 'dark-romance',
    title: 'Lower reader counts in this sample',
    rows: [
      ["darkromance", true, "–", 18, 3494, "Nocticadia · Keri Lake"],
      ["mroczny romans", false, "dark romance literal Polish", 16, 2376, "Pen Pal · J.T. Geissinger"],
      ["mafia romance", true, "–", 53, 1271, "Phantom · H.D. Carlton"],
      ["od nienawiści do miłości", false, "from hate to love", 36, 946, "Nie zbliżaj się · A.P. Mist"],
      ["anti-hero", true, "–", 6, 852, "God of Pain · Rina Kent"],
      ["touch her and die", true, "–", 11, 717, "Przysięga zemsty · Jaclyn Rodriguez"],
      ["morally gray", true, "–", 27, 85, "Amid Clouds and Bones · Ella Fields"],
      ["morally grey", true, "–", 7, 11, "Bride of Brutal Hearts · Kate Stevens"],
      ["mafia boss", true, "–", 4, 3, "Fangs for the Memories · Hattie Jacks"],
    ],
  },
  {
    genre: 'romantasy',
    title: 'Genre and age labels',
    rows: [
      ["new adult", true, "–", 1821, 236934, "Szklany Tron · Sarah J. Maas"],
      ["paranormal romance", true, "–", 1935, 195848, "Miasto kości · Cassandra Clare"],
      ["fantasy dla młodzieży", false, "YA fantasy", 50, 175999, "Niezgodna · Veronica Roth"],
      ["romantasy", true, "–", 3159, 158507, "Czerwona Królowa · Victoria Aveyard"],
      ["fantasy romance", true, "–", 3302, 109008, "Krew i Popiół · Jennifer L. Armentrout"],
      ["dark fantasy", true, "–", 1073, 66170, "Pokrzywa i kość · T. Kingfisher"],
      ["romans paranormalny", false, "paranormal romance", 182, 50830, "Pusta noc · Paulina Hendel"],
      ["young adult fantasy", true, "–", 262, 48498, "Porwana Pieśniarka · Danielle L. Jensen"],
      ["romans fantasy", false, "fantasy romance", 32, 25227, "Zawód wiedźma · Olga Gromyko"],
      ["new adult fantasy", true, "–", 13, 15208, "Darkfever · Karen Marie Moning"],
    ],
  },
  {
    genre: 'romantasy',
    title: 'Creatures and magic',
    rows: [
      ["magia", false, "magic", 3477, 1109794, "Harry Potter i Kamień Filozoficzny · J.K. Row…"],
      ["wampiry", false, "vampires", 1311, 359159, "Miasto upadłych aniołów · Cassandra Clare"],
      ["demony", false, "demons", 796, 305414, "Miasto kości · Cassandra Clare"],
      ["wilkołaki", false, "werewolves", 341, 163800, "Miasto upadłych aniołów · Cassandra Clare"],
      ["anioły", false, "angels", 438, 161217, "Szeptem · Becca Fitzpatrick"],
      ["fae", true, "–", 1402, 149718, "Szklany Tron · Sarah J. Maas"],
      ["elfy", false, "elves", 337, 135305, "Krew elfów · Andrzej Sapkowski"],
      ["smoki", false, "dragons", 604, 103684, "Iron Flame. Żelazny płomień · Rebecca Yarros"],
      ["czarownice", false, "witches", 287, 90429, "Córka czarownic · Dorota Terakowska"],
      ["witches", true, "–", 625, 37569, "Gołąb i Wąż · Shelby Mahurin"],
      ["wróżki", false, "fairies", 219, 29110, "Waleczna Czarownica · Danielle L. Jensen"],
      ["zmiennokształtni", false, "shapeshifters", 243, 24841, "Wiatr przez dziurkę od klucza · Stephen King"],
      ["dragons", true, "–", 716, 16497, "Kiedy wykluł się Księżyc · Sarah A. Parker"],
      ["shapeshifters", true, "–", 815, 7486, "Wilczy Król · Lauren Palphreyman"],
    ],
  },
  {
    genre: 'romantasy',
    title: 'World and story',
    rows: [
      ["mitologia", false, "mythology", 730, 153976, "Mitologia · Jan Parandowski"],
      ["bogowie", false, "gods", 240, 129558, "Mitologia · Jan Parandowski"],
      ["arystokracja", false, "aristocracy", 195, 79939, "Jedyna · Kiera Cass"],
      ["baśń", false, "fairy tale", 495, 70968, "Opowieści z Narnii · C.S. Lewis"],
      ["akademia", false, "academy", 60, 50370, "Akademia Pana Kleksa · Jan Brzechwa"],
      ["retelling", true, "–", 148, 46031, "Cinder · Marissa Meyer"],
      ["dark academia", true, "–", 171, 38012, "Babel, czyli o konieczności prze… · Rebecc…"],
      ["retellings", true, "–", 471, 22804, "Pieśń Syreny · Alexandra Christo"],
      ["uczelnia", false, "university, academy", 30, 21180, "Fourth Wing. Czwarte Skrzydło · Rebecca Y…"],
      ["dwór królewski", false, "royal court", 16, 13886, "Cienie między nami · Tricia Levenseller"],
    ],
  },
  {
    genre: 'romantasy',
    title: 'Tropes',
    rows: [
      ["przeznaczenie", false, "destiny, fate", 277, 184541, "Sto lat samotności · Gabriel García Márquez"],
      ["enemies to lovers", true, "–", 1513, 120681, "Krew i Popiół · Jennifer L. Armentrout"],
      ["slow burn", true, "–", 855, 70877, "The Spanish Love Deception · Elena Armas"],
      ["zakazana miłość", false, "forbidden love", 103, 68936, "Cisza · Becca Fitzpatrick"],
      ["aranżowane małżeństwo", false, "arranged marriage", 47, 30984, "Złączeni pokusą · Cora Reilly"],
      ["zabójczyni", false, "female assassin", 23, 19754, "Królowa cieni · Sarah J. Maas"],
      ["wybraniec", false, "the chosen one", 9, 17300, "Niekończąca się historia · Michael Ende"],
    ],
  },
  {
    genre: 'romantasy',
    title: 'Lower reader counts in this sample',
    rows: [
      ["jeźdźcy smoków", false, "dragon riders", 17, 2448, "W pogoni za smokiem · Anne McCaffrey"],
      ["cozy fantasy", true, "–", 49, 2300, "Magia spod lady · Sarah Beth Durst"],
      ["dark fantasy romance", true, "–", 133, 2265, "Herkules. Krew · Jasmine Mas"],
      ["fated mates", true, "–", 197, 1704, "Dwór Króla Zorzy · Nisha J. Tuli"],
      ["chosen one", true, "–", 47, 675, "Nieśmiertelne Pragnienia · Chloe Gong"],
      ["fairy tale retellings", true, "–", 95, 559, "Marzenia się spełniają · Elizabeth Lim"],
      ["monster romance", true, "–", 103, 260, "I Married A Lizardman · Regine Abel"],
      ["dark romantasy", true, "–", 72, 177, "Hollow · Caroline Peckham"],
      ["court intrigue", true, "–", 46, 52, "Ashwalker · S.M. Gaither"],
    ],
  },
];
